import React, {useState, useContext, useMemo} from 'react';
import TableAntD from "../../common/TableAntD";
import Button from "../../common/Button";
import axios from "../../common/axios";
import dayjs from 'dayjs';
import {UserContext} from "../../common/UserContext";
import {Popconfirm, Button as AntdButton} from 'antd';
import {ArchiveRounded, ArrowForwardRounded} from "@mui/icons-material";
import Tooltip from "../../common/Tooltip";
import {useLocation} from "wouter";

const ActivityReportSummarySaved = () => {
    const {user} = useContext(UserContext);
    const [, navigate] = useLocation();
    const [refetchTrigger, setRefetchTrigger] = useState(0);

    const handleView = (record) => {
        // Navigate to view the saved report using the existing route with query param
        navigate(`/web/ui/view/reports/activitySummaryManager/${record.classId}/activitySummary?savedReportId=${record.activitySummaryId}`);
    };

    const handleArchive = async (record) => {
        try {
            await axios.post(`/web/ui/report/teacher/activity/archiveActivitySummary/${record.activitySummaryId}`);
            displayToastMessage('Activity summary archived successfully', null, 'success');
            setRefetchTrigger(prev => prev + 1);
        } catch (error) {
            console.error('Error archiving activity summary:', error);
            displayToastMessage(error.response?.data?.error || 'Failed to archive activity summary', null, 'error');
        }
    };

    const columns = useMemo(() => [
        {
            title: 'Name',
            dataIndex: 'reportName',
            key: 'reportName',
            render: (text, record) => (
                <AntdButton type={'link'} onClick={() => handleView(record)}>
                    <strong>{text}</strong>
                </AntdButton>
            ),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            render: (text) => text || '-',
        },
        {
            title: 'Class',
            dataIndex: 'className',
            key: 'className',
        },
        {
            title: 'Students',
            dataIndex: 'studentCount',
            key: 'studentCount',
            width: 100,
        },
        {
            title: 'Date Saved',
            dataIndex: 'createdDate',
            key: 'createdDate',
            width: 150,
            render: (date) => {
                if (!date) return '-';
                return dayjs(date).format(user?.getDateFormatString?.() || 'DD/MM/YYYY');
            }
        },
        {
            title: 'Actions',
            key: 'actions',
            width: 80,
            render: (_, record) => (
                <Popconfirm
                    title="Archive this report?"
                    onConfirm={() => handleArchive(record)}
                    okText="Archive"
                    cancelText="Cancel"
                >
                    <Tooltip title="Archive report">
                        <Button
                            type="text"
                            icon={<ArchiveRounded />}
                        />
                    </Tooltip>
                </Popconfirm>
            ),
        },
    ], [user]);

    const fetchData = (pagingParams, handleTableData, handlePagingData, abortController) => {
        axios.get('/web/ui/report/teacher/activity/userActivitySummaries', {
            signal: abortController.signal
        })
            .then(response => {
                const data = response.data || [];
                handleTableData(data);
                handlePagingData({
                    pageSize: pagingParams.pageSize,
                    totalResults: data.length,
                });
            })
            .catch(error => {
                if (error.name !== 'CanceledError') {
                    console.error('Error fetching saved summaries:', error);
                    handleTableData([]);
                    handlePagingData({
                        pageSize: pagingParams.pageSize,
                        totalResults: 0
                    });
                }
            });
    };

    return (
        <div>
            <TableAntD
                dynamicWidth={true}
                columnData={columns}
                scroll={{x: true}}
                pagingDependencies={[refetchTrigger]}
                pagingData={{
                    fetchFunction: fetchData,
                    params: {pageSize: 20}
                }}
                rowKey="activitySummaryId"
                locale={{emptyText: 'No saved summaries'}}
            />
        </div>
    );
};

export default ActivityReportSummarySaved;